import { View } from 'react-native';

function Inventory(): JSX.Element {
    //Dashboard sobre o inventário -> ex: qts por tipo, qts por status
    return <View />;
}

export default Inventory;
